import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const getInvitationToken = async ({ communityId }: { communityId: string }) =>
  apiClient.post<{ token: string }, ApiClientResponse<{ token: string }>>(
    routes.community.invitationToken(communityId),
  );
